import { render, staticRenderFns } from "./leavesRow.vue?vue&type=template&id=10c5a6dc&"
import script from "./leavesRow.vue?vue&type=script&lang=js&"
export * from "./leavesRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports